import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'
import { selectMeetingNote, setMeetingNoteChangedExternally } from '../../../../../store/meetingSummary/meetingSupport'
import { useUpdateMeetingNote } from '../../MeetingSummary/hooks/api'
import { useCallback, useMemo } from 'react'
import { addHtmlContentToState, parseIntoHeadlessEditor } from '../../MeetingSummary/MeetingResults/Lexical/utils'
import { showToast } from '../../../../../store/meetingSummary/display'
import { SelectionHandler } from '../../../../../views/Tasks/TaskDisplay'
import { ADD_TO_NOTEPAD_COMMAND } from '../../MeetingSummary/MeetingResults/Lexical/Plugins/NotepadPlugin/NotepadPlugin'

export const useTaskSelectionHandler = () => {
  const dispatch = useAppDispatch()

  const meetingNote = useAppSelector(selectMeetingNote)

  const updateMeetingNote = useUpdateMeetingNote()

  const handleAddToNotepadCommand = useCallback(
    async (selection: string) => {
      const headlessEditor = parseIntoHeadlessEditor(meetingNote)

      addHtmlContentToState(headlessEditor, selection)

      const newMeetingNote = JSON.stringify(headlessEditor.getEditorState().toJSON())
      await updateMeetingNote(newMeetingNote)

      dispatch(setMeetingNoteChangedExternally(true))
      dispatch(showToast({ variant: 'success', icon: 'bi-check-circle-fill', message: 'Added to notepad!' }))
    },
    [dispatch, meetingNote, updateMeetingNote],
  )

  const selectionHandlers: SelectionHandler[] = useMemo(() => {
    return [
      {
        id: 'send-to-notepad',
        label: 'Send to Notepad',
        lexicalCommand: ADD_TO_NOTEPAD_COMMAND,
        scope: {
          scope: 'meeting_note:update',
          superScope: ['meeting_note:admin'],
        },
        handle: handleAddToNotepadCommand,
      },
    ]
  }, [handleAddToNotepadCommand])

  return { selectionHandlers }
}
